export default __webpack_public_path__ + "static/5905v5907-cf84ff5ec9e623057be7e2fd621a2531.webp";